<template lang="pug">
    v-dialog(v-model="dialog" max-width="640" scrollable persistent :fullscreen="$vuetify.breakpoint.smAndDown")
        v-card(tile)
            v-overlay(:value="saving" absolute)
                v-progress-circular(indeterminate size="64")
            v-card-title.title.caption--text Mention
            v-container(tag="v-card-text" gris-list-xl)
                v-form(id="formId_B0SK74" ref="refForm" @submit.prevent="onSubmit")
                    v-layout(wrap)
                        v-flex(xs12)
                            v-autocomplete(
                                v-model="users"
                                :disabled="fetching"
                                :loading="fetching"
                                :items="availableUsers"
                                chips
                                color="blue-grey lighten-2"
                                :label="$t('general.select')"
                                item-text="name"
                                item-value="id"
                                multiple
                                clearable)
                                template(v-slot:selection='data')
                                    v-chip(v-bind='data.attrs' :input-value='data.selected' close @click='data.select' @click:close='remove(data.item)')
                                        v-avatar(left)
                                            v-img(:src='data.item.avatar ? data.item.avatar : userAvatarColor')
                                        | {{ data.item.name }}
                                template(v-slot:item='data')
                                    v-list-item-avatar
                                        img(:src='data.item.avatar ? data.item.avatar : userAvatarColor').elevation-1
                                    v-list-item-content
                                        v-list-item-title(v-html='data.item.name')
                                        v-list-item-subtitle {{data.item.company.code}} - {{data.item.email}}

            v-card-actions
                v-btn(@click="close" color="grey" depressed).px-3.white--text
                    v-icon(left dark) mdi-cancel
                    | {{$t('general.cancel')}}
                v-spacer
                v-btn(type="submit" form="formId_B0SK74" color="primary" depressed).px-3
                    v-icon(left dark) mdi-content-save
                    | {{$t('general.ok')}}
</template>

<script>
import general from "../../mixins/general";
import auth from "../../mixins/auth";

export default {
  name: "MentionDialog",
  mixins: [general, auth],
  data() {
    return {
      dialog: false,
      saving: false,
      availableUsers: [],
      fetching: false,
      users: [],
      cancelFetchUsers: null,
      submitCb: null
    };
  },
  computed: {
    showing: {
      get() {
        return this.dialog;
      }
    }
  },
  methods: {
    clear() {
      this.cancelFetchUsers = null;
      this.users = [];
      this.availableUsers = [];
      this.fetching = false;
      this.submitCb = null;
    },
    close() {
      if (this.fetching && typeof this.cancelFetchUsers === "function")
        this.cancelFetchUsers("cancel fetch users");
      this.clear();
      this.dialog = false;
    },
    show({ mentionUserIds, roomId }, submitCb) {
      this.clear();
      this.submitCb = submitCb;
      this.dialog = true;
      this.$nextTick(() => {
        this.fetchUsers(roomId, mentionUserIds);
      });
    },
    onSubmit() {
      if (typeof this.submitCb === "function")
        this.submitCb(
          [...this.users],
          [...this.availableUsers.filter(u => this.users.includes(u.id))]
        );
      this.close();
    },
    fetchUsers(roomId, mentionUserIds = []) {
      this.fetching = true;
      let self = this;
      this.axios
        .get(`rooms/${roomId}/users`, {
          cancelToken: new this.axios.CancelToken(function executor(c) {
            self.cancelFetchUsers = c;
          })
        })
        .then(res => {
          this.availableUsers = res.data.data.filter(
            u => this.user.id !== u.id
          );
          this.users = this.availableUsers
            .filter(u => mentionUserIds.includes(u.id))
            .map(i => i.id);
        })
        .finally(() => (this.fetching = false));
    },
    remove(item) {
      const index = this.users.indexOf(item.id);
      if (index >= 0) this.users.splice(index, 1);
    }
  }
};
</script>

<style scoped></style>
